export const MAX_SIZE_MB = {
  image: 10,
  video: 1000, //accommodate large video files from iPhones
  pdf: 20,
};

export const LARGE_VIDEO_FILE_SIZE_WARNING_MB = 200;

export function getFileType(input: {
  type?: string;
  mimeType?: string;
}): "image" | "video" | "pdf" | "other" {
  const mime = input.type || input.mimeType || "";
  if (mime.startsWith("image/")) return "image";
  if (mime.startsWith("video/")) return "video";
  if (mime === "application/pdf") return "pdf";
  return "other";
}

/**
 * Validates file size for uploads. Accepts either a File (browser) or an object with size, name, and type/mimeType (Node).
 * Returns an error string if too large, or null if valid.
 */
export function validateFileSize(file: {
  size: number;
  name: string;
  type?: string;
  mimeType?: string;
}): string | null {
  const fileType = getFileType(file);
  const maxSize =
    fileType in MAX_SIZE_MB
      ? MAX_SIZE_MB[fileType as keyof typeof MAX_SIZE_MB]
      : 10; // fallback to 10MB
  const maxSizeBytes = maxSize * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    return `File "${file.name}" is too large. Max size for ${fileType}s is ${maxSize} MB.`;
  }
  return null;
}
